import { ElMessage } from 'element-plus'
import { AxiosErrorType } from '@/shared/types'
import { removeToken } from '@/shared/utils'
import router from '@/apps/router'

export const showErrorMessage = (error: AxiosErrorType): void => {
  if (error.status === 401) {
    removeToken()
    router.push({ name: 'AuthPage' })
  }

  if (error.errors) {
    for (const message of error.errors) {
      ElMessage({
        message,
        type: 'error',
      })
    }
  } else {
    const message = 'Что-то пошло не так. Попробуйте позже'
    ElMessage({
      message,
      type: 'error',
    })
  }
}
